<template>
	<div class="add-expert">

		<div class="content">
			<van-field clickable name="contacts" required label="收件人" placeholder="收件人名字" v-model="formData.contacts"
				input-align="left" error-message-align="left" :error-message="validate.fieldMsg.contacts" />
			<van-field clickable name="tel" required label="手机号" placeholder="手机号" v-model="formData.tel" input-align="left"
				error-message-align="left" :error-message="validate.fieldMsg.tel" />
			<van-field readonly input-align="left" clickable name="city" required :value="city" label="所在地区"
				placeholder="省 市 区 街道" @click="showArea = true" error-message-align="right"
				:error-message="validate.fieldMsg.contactCity" />
			<van-popup v-model="showArea" position="bottom">
				<van-area :area-list="areaList" @confirm="areaConfirm" @cancel="showArea = false" />
			</van-popup>
			<van-field clickable name="contactAddress" required v-model="formData.contactAddress" label="详细地址"
				placeholder="请输入详细地址" input-align="left" error-message-align="left"
				:error-message="validate.fieldMsg.contactAddress" />

			<van-field clickable name="remark" v-model="formData.remark" autosize rows="4" type="textarea" maxlength="300"
				label="备注" placeholder="请输入备注" show-word-limit input-align="left" :error-message="validate.fieldMsg.synopsis"
				error-message-align="left" :style="{ marginBottom: '20px' }" />

			<div class="create">
				<van-button size="large" @click="commitInfo"
					color="linear-gradient(to right, #5DD682, #5AFF8E)">提交申领</van-button>
			</div>
		</div>

	</div>
</template>

<script>
import { areaList } from "@vant/area-data";


import {
	certApply,
	certPay
} from "@/utils/api/cert";

import {
	signature
} from "@/utils/mixin/wx-js-sdk-signature";
import {
	wxlogin
} from "@/utils/mixin/wxlogin";
import { validate } from "@/utils/mixin/validate";
import Crop from "@/components/pub/CompressCrop.vue";
export default {
	mixins: [signature, wxlogin, validate],

	components: {
		Crop
		// SignTitle
	},
	data() {
		return {
			time: '',
			TT: {},
			openid: '',
			certId: '',
			workId: '',
			formData: {
				contacts: '',
				tel: '',
				contactAdress: '',
				contactArea: '',
				contactCity: '',
				contactProvince: '',
			},
			// 省市区
			city: "",
			// 区域树
			areaList,
			// 显示区域选择
			showArea: false,

		};
	},

	mounted() {
		this.validate.setFormDataKey("formData");
		this.workId = this.$route.query.workId || ''
this.time = this.$route.query.time || ''
	},
	methods: {

		// 区域确定
		areaConfirm(values) {
			this.city = `${values[0].name} ${values[1].name} ${values[2].name}`;
			this.formData.contactProvince = values[0].name;
			this.formData.contactCity = values[1].name;
			this.formData.contactArea = values[2].name;

			this.formData.contactProvinceId = values[0].code;
			this.formData.contactCityId = values[1].code;
			this.formData.contactAreaId = values[2].code;

			this.showArea = false;
		},


		// wxlogin callback 微信登录回调
		wxLoginCallback() {
			const { workId } = this.$route.query;
			let params = {};
			if (workId) params.workId = workId;
			// 刷新页面js权限
			this.$root.mipLink("/cert/apply", params);
		},

	


		commitInfo() {
			var that = this

			if (!that.formData.contacts) {
				that.$root.$toast.fail("请填写收件人");
				return;
			}

			if (!(that.formData.tel && that.formData.tel.length == 11)) {
				that.$root.$toast.fail("请填写正确手机号");
				return;
			}

			if (!that.formData.contactArea) {
				that.$root.$toast.fail("请选择单位地址");
				return;
			}
			if (!that.formData.contactAddress) {
				that.$root.$toast.fail("请填写详细地址");
				return;
			}

			certApply({
				url: '/certOrder/applyPaperCert',
				...that.formData,
				workId: that.workId
			}).then(res => {
				console.log(res)
				if (res.success) {
					that.$root.$toast.success('您已提交申领,请付款');
					that.certId = res.data.id


					that.$router.replace({
						path: '/cert/detail',
						query: {
							id: that.certId,
							time: that.time
						}
					})

				}
			})
		},
	
	},



};
</script>

<style lang="scss" scoped>
.add-expert {
	overflow: hidden;
	background: #F9F9FA;
	min-height: 100vh;

	.content {
		border-radius: 15px;
	}

	.tags {
		.van-tag {
			height: 32px;
			margin-left: 3px;
			margin-bottom: 3px;
			border-radius: 4px;
			border: #f2f2f2;
			min-width: 60px;
			background-color: #ecf5ff;
			color: #666;
			font-size: 12px;
			text-align: center;
			display: inline-block;
			line-height: 26px;
		}
	}

	.create {
		margin: 0 auto;
		width: 254px;
		margin-top: 40px;
		margin-bottom: 60px;

		.van-button {
			border-radius: 16px;
			width: 254px;
			height: 32px;
		}
	}
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";

.add-expert {
	text-align: left;

	.van-cell {
		&::after {
			border: none;
		}
	}

	.van-uploader {
		@include from-upload-style;
	}

	.custom-title {
		color: #646566;
	}

	.custom-tit {
		font-size: 12px;
		color: #ccc;
	}

	.expert-userImg {
		text-align: left;
		padding-top: 10px;
		padding-left: 10px;
		background: #fff;
	}

	.custom-span {
		color: #ccc;
	}

	.affixs-label {
		width: unset;

		&+.van-field__value {
			display: none;
		}
	}
}
</style>
